import { MxheroShareConfig } from "@dashboard-v3/api";
import { MenuItem, SelectProps, Typography } from "@material-ui/core";
import SelectField from "components/Forms/SelectField";
import { useTranslation } from "react-i18next";

import WithIconHelper from "components/WithIconHelper";
import { useStyles } from "../styles";

interface RegionProps {
  disabled: boolean;
  value: string;
  onChange: (update: Partial<MxheroShareConfig>) => void;
}

enum Region {
  US = "US",
  JP = "JP",
}

export default function RegionOptions(props: RegionProps) {
  const { t } = useTranslation("mxheroShares");
  const { value, disabled } = props;
  const classes = useStyles();

  const onChange: SelectProps["onChange"] = e => {
    const { value } = e.target;
    props.onChange({ region: value as Region });
  };

  return (
    <div className={classes.inputContainer} style={{ maxWidth: "50%" }}>
      <div style={{ marginBottom: 10 }}>
        <Typography variant="subtitle2">
          {t("settings.regionStorage.title")}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {t("settings.regionStorage.subtitle")}
        </Typography>
      </div>
      <WithIconHelper
        position="after"
        buttonStyles={{ marginLeft: "10px" }}
        text={t("settings.regionStorage.helper")}
      >
        <SelectField
          fullWidth={false}
          disabled={disabled}
          options={Object.values(Region)}
          style={{ width: "250px" }}
          value={value}
          onChange={onChange}
          renderOption={opt => (
            <MenuItem key={opt} value={opt}>
              {t(`settings.storageRegionOption.${opt}`) as string}
            </MenuItem>
          )}
        />
      </WithIconHelper>
    </div>
  );
}
